/** Constants shared by both RLHF rating tracks. */

/**
 * Mirrors MIN_REMARKS_LENGTH in the backend routers (rlhf_rating.py and rlhf_pairwise.py) — both
 * reject anything shorter, so the two ends must agree.
 */
export const MIN_REMARKS_LENGTH = 10;

/**
 * Width of a rating page's content column, shared by the page and its fixed bottom bar so the
 * bar's controls stay aligned under the content. Both tracks use it: they lay out a brief and a
 * report side by side and need the same measure.
 */
export const RATING_CONTENT_MAX_WIDTH = 'max-w-[1500px]';
